<sm-table2 *ngIf="table != null" class="height100p" [data]="table" [compact]=false [autoRowHeight]=true [floatingFilter]=true></sm-table2>
